import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductCard.css';
import { getAssetUrl } from '../config/api';

const ProductCard = ({ product, onAddToCart, featured }) => {
  const [isWishlisted, setIsWishlisted] = useState(false);
  const navigate = useNavigate();

  const handleWishlistClick = (e) => {
    e.stopPropagation();
    setIsWishlisted(!isWishlisted);
  };

  const handleCardClick = () => {
    navigate(`/product/${product._id || product.id}`);
  };

  // Get first image: default images → first color variant image → gradient fallback
  const getImageStyle = () => {
    let imageUrl = null;

    if (product.images && product.images.length > 0) {
      imageUrl = getAssetUrl(product.images[0]);
    } else if (product.colorVariants && product.colorVariants.length > 0) {
      for (const variant of product.colorVariants) {
        if (variant.images && variant.images.length > 0) {
          imageUrl = getAssetUrl(variant.images[0]);
          break;
        }
      }
    }

    if (imageUrl) {
      return {
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    }
    return { background: product.gradient };
  };

  return (
    <div className={`product-card ${featured ? 'featured' : ''}`} onClick={handleCardClick}>
      <div className="product-image" style={getImageStyle()}>
        <button className="wishlist-btn" onClick={handleWishlistClick}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill={isWishlisted ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.5">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
        </button>
      </div>
      <div className="product-info">
        {product.badge && <span className="product-label">{product.badge}</span>}
        <h3 className="product-name">{product.name}</h3>
        <p className="product-price">৳{product.price}</p>
      </div>
    </div>
  );
};

export default ProductCard;
